import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=a88f8836&scoped=true&"
import script from "./UsersManagement.vue?vue&type=script&lang=js&"
export * from "./UsersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88f8836",
  null
  
)

export default component.exports